import { INTERACTIVE_LINKS } from 'utils/constants';
import { routes } from 'utils/routes';

export const TEAM = [
  {
    name: 'Dmitry',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/4AlGEoLzj3iF5AuFNiBHS9/2abfed64e6fd991ef02f49aa4714f8b9/Dzimitry-Babrou.jpg',
    path: '/person/dmitry',
  },
  {
    name: 'Sofia',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/5IMwm9ytTZlJnlQ45btYQ6/1ae488d79c723a25f15c871231707f64/fdba7a3d3f83799e1087b672361f5a2bc68a78b6.png',
    path: '/person/sofia',
  },
  {
    name: 'Mikita',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/7m4Z4lptksMscgP6RoyKza/2ca912125e97cba134acf8eb6d026625/mikita.jpg',
    path: '/person/mikita',
  },
  {
    name: 'Vlad',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/47k219ZNgOacNZPTFimBGx/7222776055f9869f27470fb76c4931dc/e46eb7a38772c7cd4d56104c5f1899fffd677002.png',
    path: '/person/vlad',
  },
];

export const TECH_STACK = [
  'pythonColor',
  'jsColor',
  'tensorflowColor',
  'pytorchColor',
  'claudeColor',
  'spaCyColor',
  'ocrColor',
  'langGraphColor',
  'reactColor',
  'nodeColor',
];

export const CLIENTS_LIST = [
  {
    path: 'https://writer.com/',
    icon: 'writerColor',
    title: 'Writer',
  },
  {
    path: 'https://www.netflix.com/',
    icon: 'netflixColor',
    title: 'Netflix',
  },
  {
    path: 'https://www.mcdonalds.com',
    icon: 'mcDonaldsColor',
    title: 'MCD',
  },
  {
    path: 'https://www.allianz.com/en.html',
    icon: 'allianzColor',
    title: 'Allianz',
  },
];

export const YELLOW_NUMBERS = [
  {
    title: '$2.1B+',
    description: 'Value generated through AI innovation',
  },
  {
    title: '47',
    description: 'Custom LLMs and AI agents deployed',
  },
  {
    title: '30M+',
    description: 'Engaging with products we created',
  },
  {
    title: '98%',
    description: 'Projects delivered within agreed budget',
  },
];

export const SERVICES = [
  {
    icon: 'generativeAi',
    title: 'Generative AI',
    path: routes.generativeAiDevelopment.path,
  },
  {
    icon: 'llmDev',
    title: 'LLM',
    path: routes.llmDevelopment.path,
  },
  {
    icon: 'aiAgent',
    title: 'AI Agents',
    path: routes.aiAgentsServices.path,
  },
  {
    icon: 'rag',
    title: 'RAG',
    path: routes.ragDevelopment.path,
  },
  {
    icon: 'computerVision',
    title: 'Computer Vision',
    path: routes.computerVisionServices.path,
  },
  // {
  //   icon: 'machineLearning',
  //   title: 'ML&MLOps',
  //   path: routes.mlOpsDevelopment.path,
  // },
  // {
  //   icon: 'aiDev',
  //   title: 'AI Development',
  //   path: routes.aiDevelopment.path,
  // },
  // {
  //   icon: 'machineLearning',
  //   title: 'ML Development',
  //   path: routes.mlDevelopment.path,
  // },
  // {
  //   icon: 'chatAi',
  //   title: 'AI Chatbots',
  //   path: routes.aiChatbotDevelopmentServices.path,
  // },
  // {
  //   icon: 'robot',
  //   title: 'AI Copilots',
  //   path: routes.aiCopilot.path,
  // },
];

export const NAVIGATION = [
  {
    title: 'About us',
    description: 'Who we are and our mission in the AI landscape.',
    path: routes.company.path,
  },
  {
    title: 'Why us',
    description: 'Our competitive edge and technical expertise.',
    path: routes.whyUs.path,
  },
  {
    title: 'Blog',
    description: 'Insights on the latest AI trends and practical use cases.',
    path: routes.blog.path,
  },
];

export const SERVICES_FULL = [
  {
    icon: 'aiDev',
    title: 'AI Development',
    path: routes.aiDevelopment.path,
  },
  {
    icon: 'monitor01',
    title: 'Software Engineering',
    path: routes.customWebApp.path,
  },
  {
    icon: 'penTool',
    title: 'UI/UX Design',
    path: routes.designServices.path,
  },
  {
    icon: 'test',
    title: 'QA',
    path: routes.softwareQualityAssuranceServices.path,
  },
  {
    icon: 'database',
    title: 'DevOps',
    path: routes.devOpsDevelopment.path,
  },
];

export const FEATURED_CASES_PREVIEWS = [
  {
    name: 'Writer Framework Platform',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/6d2Af7ssqcDS25QigSS4XE/8db821387e8d7d4ac178f9886caac3c3/Image__22_.png',
    path: '/works/writer-framework-platform',
  },
  {
    name: 'Predictive Lead Scoring with AI',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/YZ1RovcSrMqDjMtoChUr4/91c079b7b5c384a09e06aa7dca21c60f/Image__18_.png',
    path: '/works/predictive-ai-for-marketing',
  },
  {
    name: 'AML Detection Tool',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/3dvGVPSE65lHxsYDchTicM/3805ef750c52b88297831687ce8c5bee/Image__19_.png',
    path: '/works/enhancing-money-laundering-mention-extraction',
  },
  {
    name: 'AI Concierge Agent',
    image: 'https://images.ctfassets.net/ic8vz4cuikua/7kioBcRy5uzIa66gvGNSDk/2c96478ea4d2b459e9af985440d84582/Image__20_.png',
    path: '/works/ai-concierge-for-hotel-network',
  },
];

export const FEATURED_CASES = [
  {
    title: 'AI Framework for Writer',
    path: '/works/writer-framework-platform',
  },
  {
    title: 'AI Tool for Process Optimization',
    path: '/works/ai-documentation-processing',
  },
  {
    title: 'HR AI Agent',
    path: '/works/ai-agent-for-pre-screening',
  },
  {
    title: 'Hotel Booking AI Agent',
    path: '/works/ai-concierge-for-hotel-network',
  },
  {
    title: 'AI Voice Agent for e-Learning',
    path: '/works/ai-voice-assistant-for-e-learning',
  },
  {
    title: 'Computer vision for ARAS',
    path: '/works/computer-vision-for-aras',
  },
];

export const PROJECTS = [
  {
    title: 'AI Learning Personalization',
    description: 'Smart content recommendations',
    path: '/works/ai-for-edtech',
  },
  {
    title: 'Hotel AI Concierge',
    description: 'AI assistant for hotel guests',
    path: '/works/ai-concierge-for-hotel-network',
  },
  {
    title: 'Claims Documentation Automation',
    description: 'Platform for faster claims processing',
    path: '/works/llm-for-insurtech-saas',
  },
  {
    title: 'AI for Candidate Screening',
    description: 'Smart HR efficiency booster',
    path: '/works/ai-agent-for-pre-screening',
  },
  {
    title: 'AI Voice Agent',
    description: 'AI agent for hands-free learning',
    path: '/works/ai-voice-assistant-for-e-learning',
  },
  {
    title: 'LLM Legal Summarization',
    description: 'Efficient and fast legal summaries',
    path: '/works/llm-legal-document-summarization',
  },
  {
    title: 'Vision-Based Driving Assistance',
    description: 'Real-time threat detection system',
    path: '/works/computer-vision-for-aras',
  },
];

export const MOBILE_MENU = {
  [INTERACTIVE_LINKS.company.slug]: [
    {
      title: 'Navigation',
      items: [...NAVIGATION],
    },
  ],
};
